import IndexedDB from "@/helpers/IndexedDB.js";

export default class UploadFile {
	constructor({
		id,
		bucket_path,
		original_name,
		typology_id,
		is_public,
		role_id,
		job_id,
		upload_type,
		object_type,
		url_file,
	}) {
		this.id = id || 0;
		this.upload_type = upload_type || "";
		this.object_type = object_type || "";
		this.url_file = url_file || "";
		this.bucket_path = bucket_path || "";
		this.original_name = original_name || "";
		this.typology_id = typology_id || 0;
		this.is_public = is_public || 0;

		if (this.upload_type === "RESOURCE") this.role_id = role_id || 0;
		if (this.upload_type === "LAYER") this.job_id = job_id || "";
	}

	async saveToIndexedDB() {
		let uploadFile = this;
		try {
			await IndexedDB.save("upload_files", uploadFile, uploadFile.id);
		} catch (error) {
			throw new Error(error);
		}
	}

	getUploadedFiles() {
		return IndexedDB.getAll("upload_files");
	}

	downloadFileTxt(filename, text) {
		let element = document.createElement("a");
		element.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(text));
		element.setAttribute("download", filename);
		element.style.display = "none";
		document.body.appendChild(element);
		element.click();
		document.body.removeChild(element);
	}

	downloadFile(filename, url) {
		return new Promise((resolve, reject) => {
			fetch(url)
				.then((resp) => {
					if (resp.status === 404) {
						throw new Error("Something was wrong");
					}
					return resp.blob();
				})
				.then((blob) => {
					const url = window.URL.createObjectURL(blob);
					const a = document.createElement("a");
					a.style.display = "none";
					a.href = url;
					// the filename you want
					a.download = filename;
					document.body.appendChild(a);
					a.click();
					window.URL.revokeObjectURL(url);
					resolve("ok");
				})
				.catch((err) => {
					reject(err);
				});
		});
	}
}
